import { inject } from '@angular/core';

import { map, take } from 'rxjs';

import { AuthRestaurantService } from '@tablesready/frontend-store';
import { PricePlansRestrictionsService, PricePlansRestrictionsModalService } from '../services';

export const businessPlanGuard = () => {
  const authRestaurantService = inject(AuthRestaurantService);
  const pricePlansRestrictionsService = inject(PricePlansRestrictionsService);
  const pricePlansRestrictionsModalService = inject(PricePlansRestrictionsModalService);

  const user = authRestaurantService.get();
  const isLocationOnBusinessPlan = pricePlansRestrictionsService.availableForBusinessPlan(user.account.subscriptionType, user.location.recurly);

  if (!isLocationOnBusinessPlan) {
    return pricePlansRestrictionsModalService.display(user, false)
      .pipe(
        take(1),
        map(() => false),
      );
  }

  return true;
};
